module.exports = __webpack_public_path__ + "img/product_24.90ddb2e.webp";